import type { FunctionComponent } from 'react'

import { FlowPage, H2 } from '@monthio/design-system'
import {
	AssetExpensesIntroExplainerIcon1,
	AssetExpensesOverviewIcon,
} from '@monthio/icons'
import { useTranslation } from 'react-i18next'

import {
	ExplainerList,
	ExplainerListItem,
} from '../../../modulesTemp/general/FlowWizardUtils'

export const SavingsCapacityPageIntro: FunctionComponent<{
	onNext: () => void
}> = ({ onNext }) => {
	const { t } = useTranslation()

	return (
		<FlowPage>
			<FlowPage.Content $spacing="xl">
				<FlowPage.Header
					title={t('savingsCapacity-intro-header-title')}
					description={t('savingsCapacity-intro-header-subtitle')}
					slot={<AssetExpensesOverviewIcon />}
				/>
				<div>
					<H2>{t('savingsCapacity-intro-explainer-title')}</H2>
					<ExplainerList>
						<ExplainerListItem>
							<AssetExpensesIntroExplainerIcon1 width={24} height={24} />
							{t('savingsCapacity-intro-explainer-1')}
						</ExplainerListItem>
						<ExplainerListItem>
							<AssetExpensesIntroExplainerIcon1 width={24} height={24} />
							{t('savingsCapacity-intro-explainer-2')}
						</ExplainerListItem>
					</ExplainerList>
				</div>
			</FlowPage.Content>
			<FlowPage.Footer
				actions={
					<FlowPage.Cta onClick={onNext}>
						{t('savingsCapacity-intro-button-start')}
					</FlowPage.Cta>
				}
			/>
		</FlowPage>
	)
}
